
// Project Module State
const state = {
  collection: [],
  current: {},
  fetching: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/user/state.js